import angular from 'angular'

import template from './view/goodsContrastTemplate.html'
import { goodsContrast } from 'redevConfig'

const list = (goodsContrast && goodsContrast.list) || ''
const add = (goodsContrast && goodsContrast.add) || ''

const goodsContrastLis = list ? require(`redevelopment/outputManage/goodsContrast/${list.templateName}`) : require('./view/goodsContrastList.html')
const goodsContrastListCtrl = list ? require(`redevelopment/outputManage/goodsContrast/${list.controllerName}`) : require('./goodsContrastListCtrl')

const editGoodsContrast = add ? require(`redevelopment/outputManage/goodsContrast/${add.templateName}`) : require('./view/editGoodsContrast.html')
const editGoodsContrastCtrl = add ? require(`redevelopment/outputManage/goodsContrast/${add.controllerName}`) : require('./editGoodsContrastCtrl')

function config ($stateProvider) {
  $stateProvider
    .state('outputManage.ovat.goodsContrast', {
      url: '/goodsContrast',
      template,
      abstract: true,
      title: '商品对照表',
      default: 'outputManage.ovat.goodsContrast.list',
    })
    .state('outputManage.ovat.goodsContrast.list', {
      url: '/list',
      template: goodsContrastLis,
      controller: 'goodsContrastListCtrl',
    }).state('outputManage.ovat.goodsContrast.add', {
      url: '/add',
      template: editGoodsContrast,
      controller: 'editGoodsContrastCtrl',
      title: '新增',
    })
    .state('outputManage.ovat.goodsContrast.edit', {
      url: '/edit/:id',
      template: editGoodsContrast,
      controller: 'editGoodsContrastCtrl',
      title: '编辑',
    })
}
export default angular
  .module('outputManage.ovat.goodsContrast', [])
  .config(['$stateProvider', config])
  .controller('goodsContrastListCtrl', goodsContrastListCtrl.default)
  .controller('editGoodsContrastCtrl', editGoodsContrastCtrl.default)
  .name



// WEBPACK FOOTER //
// ./src/app/outputManage/baseData/goodsContrast/index.js